var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 103,
    viewBox: "0 0 78 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.75 60.675C58.7595 66.7636 56.3956 72.6161 52.16 76.99C49.801 79.4122 46.9265 81.2716 43.75 82.43M73.75 62.21C73.75 29.325 38.75 3.75 38.75 3.75C38.75 3.75 3.75 29.325 3.75 62.21C3.75 71.9 7.435 81.195 14 88.05C20.565 94.905 29.47 98.75 38.75 98.75C48.03 98.75 56.935 94.9 63.5 88.05C70.065 81.2 73.75 71.9 73.75 62.205",
    stroke: "black",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/Color.0404337160e7d9c5bc4d710b3fa3532f.svg";
export { ForwardRef as ReactComponent };